<script setup>
import ConfigurationTab from '@/views/quality/risk/masters/ConfigurationTab.vue'
import QuestionnaireTab from '@/views/quality/risk/masters/QuestionnaireTab.vue'

definePage({
  meta: {
    subject: 'risk.menu',
    action: 'masters',
    navActiveLink: 'app-quality-risk-masters-types',
  },
})

const route = useRoute()
const router = useRouter()

const typeId = ref(route.params.id ? Number(route.params.id) : null)
const typeName = ref(null)
const tab = ref('configuration')

// Creating a type turns this page from create into edit without a reload, so
// the Questionnaire tab unlocks the moment the record exists — the same
// behaviour as the audit setup page.
const onSaved = record => {
  if (!record?.id) return
  typeName.value = record.name
  if (typeId.value === null) {
    typeId.value = record.id
    router.replace({ name: 'app-quality-risk-masters-types-setup', params: { id: record.id } })
  }
}

// Fills the header subtitle when editing an existing type, without waiting
// for the user to press Submit — ConfigurationTab fetches the record itself
// (RiskTypeController has no single-resource GET) and surfaces it here.
const onConfigurationLoaded = record => {
  typeName.value = record?.name ?? null
}
</script>

<template>
  <section>
    <div class="d-flex align-center gap-4 mb-6">
      <IconBtn
        variant="tonal"
        class="rounded"
        size="large"
        @click="router.push({ name: 'app-quality-risk-masters-types' })"
      >
        <VIcon
          size="24"
          icon="tabler-arrow-left"
        />
      </IconBtn>
      <div>
        <div class="text-h5">
          {{ typeId ? 'Edit Risk Type' : 'Add Risk Type' }}
        </div>
        <span
          v-if="typeName"
          class="text-body-2 text-medium-emphasis"
        >
          {{ typeName }}
        </span>
      </div>
    </div>

    <VTabs
      v-model="tab"
      class="mb-6"
    >
      <VTab value="configuration">
        Configuration
      </VTab>
      <VTab
        value="questionnaire"
        :disabled="!typeId"
      >
        Questionnaire
        <VTooltip
          v-if="!typeId"
          activator="parent"
          location="top"
        >
          Save the risk type first
        </VTooltip>
      </VTab>
    </VTabs>

    <VWindow v-model="tab">
      <VWindowItem value="configuration">
        <ConfigurationTab
          :type-id="typeId"
          @saved="onSaved"
          @loaded="onConfigurationLoaded"
        />
      </VWindowItem>

      <VWindowItem value="questionnaire">
        <QuestionnaireTab
          v-if="typeId"
          :type-id="typeId"
        />
      </VWindowItem>
    </VWindow>
  </section>
</template>
